// extracted by mini-css-extract-plugin
export default {"container":"SupplierContactData_container__MkzNm","name":"SupplierContactData_name__siTlk","data":"SupplierContactData_data__xRo0i"};